import { useLayoutEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import "../DashboardLayout/DashboardLayout.css";
import "../DashboardLayout/AkasCmsTheme.css";

const POSLayout = ({ children }) => {
  const userProfile = useSelector((state) => state?.auth?.login?.profile);
  const layoutRef = useRef(null);

  useLayoutEffect(() => {
    const layout = layoutRef.current;
    const navbar = layout?.querySelector(".pos-navbar");
    if (!navbar) return;

    const updateNavbarHeight = () => {
      layout.style.setProperty("--pos-navbar-height", `${Math.ceil(navbar.getBoundingClientRect().height)}px`);
    };
    updateNavbarHeight();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(updateNavbarHeight) : null;
    observer?.observe(navbar);
    window.addEventListener("resize", updateNavbarHeight);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", updateNavbarHeight);
    };
  }, []);

  return (
    <>
      <div className="page pos-layout" ref={layoutRef}>
        {/* <Sidebar userProfile={userProfile} /> */}
        <Navbar userProfile={userProfile} />
        {children}

        {/* <Footer /> */}
      </div>
    </>
  );
};

export default POSLayout;
